const startBtn = document.querySelector(".buttonParallax");
const projectInfo = document.querySelector(".section-to-scroll");

//parallax when button was pressed
startBtn.addEventListener("click", () => {
  if (projectInfo.classList.contains("s-project__info")) {
    document.documentElement.scrollTo(0, projectInfo.offsetTop + 100, 2000);
  } else {
    document.documentElement.scrollTo(0, projectInfo.offsetTop, 2000);
  }
});
